function preserveCase(sample: string, replacement: string): string {
  if (!sample) return replacement;
  if (sample === sample.toUpperCase()) return replacement.toUpperCase();
  if (sample[0] === sample[0].toUpperCase()) {
    return `${replacement.charAt(0).toUpperCase()}${replacement.slice(1)}`;
  }
  return replacement;
}

/** Show "professional" in Ask AI replies while still accepting "technician" as input. */
export function toProfessionalWording(value: string): string {
  return String(value || '')
    .replace(/\btechnicians\b/gi, (match) => preserveCase(match, 'professionals'))
    .replace(/\btechnician\b/gi, (match) => preserveCase(match, 'professional'));
}
